// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3Id70","title":"ClientInsurance_title__20MXH","itemText":"ClientInsurance_itemText__3inyW"};